import React from 'react'

import { useSelector } from 'react-redux'

import InfluencerIdentityRowSubmissionCard from '@components/Inbox/InfluencerIdentity/Row/Submission/Card/Card'
import CardGrid from '@components/UI/CardGrid/CardGrid.styled'
import { useInfluencerIdentityId } from '@context/InfluencerIdentityId'
import { useCampaignIdFromRoute } from '@hooks/useCampaignIdFromRoute'
import { IApplicationState } from '@store'
import { selectIsSocialCampaign } from '@store/campaigns'
import { selectSubmissionIdsByInfluencerIdentity } from '@store/submissions'
import { Container } from '@tribegroup'

const InfluencerIdentityRowSubmissionList: React.FC = () => {
  const campaignId = useCampaignIdFromRoute()
  const { contextInfluencerIdentityId } = useInfluencerIdentityId()
  const isSocial = useSelector((state: IApplicationState) =>
    selectIsSocialCampaign(state, campaignId),
  )
  const submissionIds = useSelector((state: IApplicationState) =>
    selectSubmissionIdsByInfluencerIdentity(state, campaignId, contextInfluencerIdentityId),
  )

  return (
    <Container topOuterSpacing={1.25} bottomOuterSpacing={1.25}>
      <CardGrid gap={0.9375}>
        {submissionIds.map((submissionId: number) => (
          <InfluencerIdentityRowSubmissionCard
            key={submissionId}
            submissionId={submissionId}
            campaignId={campaignId}
            isSocial={isSocial}
          />
        ))}
      </CardGrid>
    </Container>
  )
}

export { InfluencerIdentityRowSubmissionList }
export default InfluencerIdentityRowSubmissionList
